import { select_device_capabilities } from 'console/redux/selectors';
import { getPhotosFromServer } from 'entities/device.photos/model/get-photos-actions';
import { any2unix } from 'utils';
import { getAPIErrorMessage } from 'api';
import { Capability } from 'console/device/device-capability';
import { openProPopup } from 'console/account/redux/action';
import { getTariffProName } from 'console/billing/account-tariff/utils';
import { selectNeedOpenAdvertisementPopup } from 'console/billing/billing-utils';
import { selectDevice } from 'entities/device/lib';
import { loadDataFromServer } from 'shared/device.map.track/api';
export function loadTrack(device_id, mintime, maxtime) {
    mintime = any2unix(mintime);
    maxtime = any2unix(maxtime);
    return async (dispatch, getState, { api }) => {
        try {
            const device = selectDevice(getState(), device_id);
            const caps = select_device_capabilities(getState(), device_id);
            if (device != null && caps != null && device_id !== null) {
                dispatch({
                    type: 'LOAD_TRACK__REQUEST',
                    device_id,
                    mintime,
                    maxtime,
                });
                try {
                    let data_types = ['gps', 'events'];
                    if (caps.includes(Capability.has_autoscan_tracking))
                        data_types = [
                            'gps',
                            'events',
                            'autoscan',
                            'autoscan_foreign',
                            'autoscan_misc',
                        ];
                    const data_result = await loadDataFromServer(api, [device_id], mintime, maxtime, data_types, { gps: { include_last_before: true } });
                    const raw_data = data_result[device_id];
                    //запрашиваю фоточки для отображения на треке
                    if (device.camera_available != null)
                        dispatch(getPhotosFromServer(device_id, mintime));
                    //Проверяем, нужно ли показывать плашку про историю тарифа ПРО
                    //Временно отключено для андроида
                    if (selectNeedOpenAdvertisementPopup(getState(), !!raw_data?.time_truncated)) {
                        dispatch(openProPopup(`2 года истории доступно в тарифе ${getTariffProName()}!`));
                    }
                    dispatch({
                        type: 'LOAD_TRACK__OK',
                        device_id,
                        mintime,
                        maxtime,
                        raw_data,
                    });
                }
                catch (error) {
                    const err_msg = getAPIErrorMessage(error, 'Не удалось загрузить данные');
                    dispatch({
                        type: 'LOAD_TRACK__FAIL',
                        device_id,
                        error: `Не удалось загрузить данные: ${err_msg}`,
                        mintime,
                        maxtime,
                    });
                }
            }
        }
        catch (EEE) {
            console.log('ERROR IN LOAD TRACK selectors', EEE);
        }
    };
}
export const setTrackingViewport = (device_id, mintime_ms, maxtime_ms) => ({
    type: 'SET_TRACKING_VIEWPORT',
    device_id,
    mintime_ms,
    maxtime_ms,
});
export const setConfirmedTrackingViewport = (device_id, mintime_ms, maxtime_ms) => ({
    type: 'SET_CONFIRMED_TRACKING_VIEWPORT',
    device_id,
    mintime_ms,
    maxtime_ms,
});
export const showGhostAtTime = (device_id, time_or_null) => ({
    type: 'SHOW_GHOST_AT_TIME',
    device_id,
    ghost_at_time: time_or_null,
});
export const hoverPointsOnMap = (device_id, points) => {
    return {
        type: 'HOVER_POINTS_ON_MAP',
        device_id,
        points,
    };
};
export const selectPointOnMap = (device_id, point) => ({
    type: 'SELECTED_POINT_ON_MAP',
    device_id,
    point,
});
